import React from 'react';
import { StudyPlanDataInterface, StudyPlanContextInterface } from '../../types';
import { CheckpointCardProps } from '@magoosh/gre/adaptive_prep_v1/organisms/checkpoint_card/types';
import { StudyPlanCheckpoint } from '../../types';
import { paths } from 'config/path_helpers';
import style from '../../style.module.scss';

// Data for the bottom checkpoint cards
export const checkpointProps = (
  checkpoint: StudyPlanCheckpoint,
  testDate: StudyPlanDataInterface['testDate']
) => {
  const checkpointProps: CheckpointCardProps = {
    headline: checkpoint.displayName,
    primaryCTA: {},
    locked: checkpoint.locked
  };

  if (checkpoint.type === 'Test Day') {
    checkpointProps.primaryCTA = {
      text: 'Read Our Tips',
      variant: 'default',
      href: paths.tips(),
      target: '_blank'
    };

    checkpointProps.secondaryCTA = {
      text: 'Change Date in Profile',
      variant: 'default',
      href: paths.profileEdit()
    };

    checkpointProps.iconType = 'CalendarStar';
    checkpointProps.estimatedTime = '2 Hours';
    checkpointProps.date = testDate;

    checkpointProps.copy =
      'You’re in the final push before your test date! You’ve already put in a lot of hard work studying, so focus on making sure you’re reviewing your weakest high and moderate significance topics. And make sure you get some rest before the big day. You got this!';
  } else if (checkpoint.type === 'Assessment') {
    checkpointProps.iconType = 'SingleStar';
    checkpointProps.estimatedTime = '65 Minutes';

    checkpointProps.copy =
      checkpoint.notAvailableYet &&
      `Study ${checkpoint.minimumEngagementHours} hours to unlock this practice.`;

    checkpointProps.scored =
      checkpoint.number === 1 ? '' : checkpoint.notScored ? '(Not Scored)' : '(Scored)';

    if (checkpoint.running) {
      checkpointProps.primaryCTA = {
        text: 'Continue',
        variant: 'default',
        href: paths.practiceTest(checkpoint.mockTestId)
      };
    } else if (checkpoint.locked || checkpoint.notAvailableYet) {
      checkpointProps.primaryCTA = { text: 'Start', variant: 'default', type: 'submit', disabled: true };
    } else {
      checkpointProps.primaryCTA = { text: 'Start', variant: 'default', type: 'submit' };
    }
  } else if (checkpoint.type === 'Practice Test') {
    checkpointProps.iconType = 'MultipleStars';
    checkpointProps.estimatedTime = '4 hours (Scored)';

    checkpointProps.copy =
      'Practice your pacing and stamina and get a snapshot of your strengths and weaknesses. Plan to take at least two practice tests, with the last one at least one week prior to your test date.';

    if (checkpoint.running) {
      checkpointProps.primaryCTA = {
        text: 'Continue',
        variant: 'default',
        href: paths.practiceTest(checkpoint.mockTestId)
      };
    } else if (checkpoint.locked) {
      checkpointProps.primaryCTA = {
        text: 'Preview',
        variant: 'default',
        href: paths.startPracticeTest()
      };
    } else {
      checkpointProps.primaryCTA = { text: 'Start', variant: 'default', href: paths.startPracticeTest() };
    }
  }

  return checkpointProps;
};
